import { registerCustomBlockType } from "../../utils/restrict-block-register";
import metadata from "./block.json";
import Edit from "./Edit";
import save from "./save";
import "./style.scss";

registerCustomBlockType(
  {
    ...metadata,
    edit: Edit,
    save,
    icon: {
      foreground: "#0061FE",
      src: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <rect
            x="3"
            y="5"
            width="18"
            height="14"
            rx="2"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
          />
          <line
            x1="3"
            y1="10"
            x2="21"
            y2="10"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <line
            x1="8"
            y1="5"
            x2="8"
            y2="19"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <line
            x1="13"
            y1="5"
            x2="13"
            y2="19"
            stroke="currentColor"
            strokeWidth="1.5"
          />
        </svg>
      ),
    },
  },
  {
    removeAncestorInTemplates: ["single-product"],
  }
);
